import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-fetal-therapy',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './fetal-therapy.component.html',
  styleUrl: './fetal-therapy.component.scss'
})
export class FetalTherapyComponent implements OnInit {

  constructor(
    private route: Router,
    private routes: ActivatedRoute,
    private metaService: Meta,
    private titleService: Title, private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit(): void {
    const homeSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "NCare IVF Kannur, Kerala",
      "image": "https://ncareivfkannur.com/assets/images/header/logo.svg",
      "@id": "https://ncareivfkannur.com/",
      "url": "https://ncareivfkannur.com/fetal-therapy",
      "telephone": "8606443030",
      "priceRange": "₹",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Balram Memorial Buidling, N.E, Rajiv Gandhi Rd",
        "addressLocality": "Kannur, Kerala",
        "postalCode": "670001",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 11.8710259,
        "longitude": 75.3641411
      },
      "sameAs": [
        "https://www.facebook.com/people/Ncare-IVF-Kannur/61574105283962/",
        "https://www.instagram.com/ncareivfkannur/",
        "https://www.youtube.com/@NCAREIVFKANNUR/"
      ]
    }

    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(homeSchema);
    this.renderer.appendChild(this.document.head, script);





    this.titleService.setTitle('Fetal Therapy in Kannur | Advanced In-Womb Treatment');
    this.metaService.updateTag({
      name: 'description',
      content: 'NCARE IVF Centre in Kannur offers expert fetal therapy for treating conditions before birth. Our fetal medicine specialists provide safe and effective in-womb procedures to ensure healthy outcomes.'
    });

    this.metaService.updateTag({
      name: 'keywords',
      content: 'Fetal Therapy, top rated fetal therapy in kannur, fetal medicine specialist in kannur, fetal care centre, fetal gene therapy, fetal medicine specialist in kannur'
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: 'Fetal Therapy in Kannur | Advanced In-Womb Treatment'
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: 'NCARE IVF Centre in Kannur offers expert fetal therapy for treating conditions before birth. Our fetal medicine specialists provide safe and effective in-womb procedures to ensure healthy outcomes.'
    });
  }
  contactus() {
    this.route.navigate(['/contact-us']);
  }
}

